import React, {useState} from 'react'


export default function FaqSection() {
    const [expandedIndex, setExpandedIndex] = useState(null);

    const toggleAccordion = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    const accordionData = [
        {
            title: "How long are Snapshot Videos?",
            content: "Snapshot Videos are typically around 90 seconds—just long enough to be quick and engaging. They can be slightly shorter or longer based on your content needs."
        },
        {
            title: "What will we need to provide?",
            content: "Simply share the five key topics you'd like to cover each month. We'll handle the scriptwriting, voiceover, and video production. If you have images from industry events or team photos, you can include those, but we aim to make the process completely turnkey for you."
        },
        {
            title: "How often can we produce a Snapshot Video?",
            content: "Snapshot Videos are designed to be produced once per month to keep your updates consistent and fresh."
        },
        {
            title: "Do credits expire?",
            content: "Yes, credits expire either 12 or 24 months from the date of purchase, depending on the package you choose."
        },
        {
            title: "Are there any additional fees?",
            content: "None at all—what you see is what you pay!"
        }
    ];

    return (
        <>
            <section className="Faq-section" id="Faq-section">
                <div className="row ">
                    <div className="container">
                        <div className="faq-wrap">
                            <div className="title wow zoomIn">
                                <h2>Frequently <span className="red">Asked Questions</span> </h2>
                            </div>
                            <div className="accordion-wrap wow fadeInLeft" id="accordion-wrap">
                                <div className="accordion">
                                    {accordionData.map((item, index) => (
                                        <div className="accordion-item" key={index}>
                                            <button id="accordion-button-1" className="acc-btn" aria-expanded={expandedIndex === index} onClick={() => toggleAccordion(index)} >
                                                <span className="accordion-title">{item.title}</span>
                                                <span className="icon" aria-hidden="true"></span>
                                            </button>
                                            <div className="accordion-content">
                                                <p>
                                                    {item.content}
                                                </p>
                                            </div>
                                        </div>
                                    ))}

                                    {/* <div className="accordion-item">
                                        <button id="accordion-button-1" className="acc-btn" aria-expanded="false">
                                            <span className="accordion-title">How long are Snapshot Videos?</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                        <div className="accordion-content">
                                            <p>
                                                Snapshot Videos are typically around 90 seconds—just long enough to be quick and engaging. They can be slightly shorter or longer based on your content needs.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <button id="accordion-button-2" className="acc-btn" aria-expanded="false">
                                            <span className="accordion-title">What will we need to provide?</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                        <div className="accordion-content">
                                            <p>
                                                Simply share the five key topics you'd like to cover each month. We'll handle the scriptwriting, voiceover, and video production. If you have images from industry events or team photos, you can include those, but we aim to make the process completely turnkey for you.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <button id="accordion-button-4" aria-expanded="false">
                                            <span className="accordion-title">How often can we produce a Snapshot Video?</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                        <div className="accordion-content">
                                            <p>
                                                Snapshot Videos are designed to be produced once per month to keep your updates consistent and fresh.

                                            </p>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <button id="accordion-button-5" className="acc-btn" aria-expanded="false">
                                            <span className="accordion-title">Do credits expire?</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                        <div className="accordion-content">
                                            <p>
                                                Yes, credits expire either 12 or 24 months from the date of purchase, depending on the package you choose.

                                            </p>
                                        </div>
                                    </div>

                                    <div className="accordion-item">
                                        <button id="accordion-button-5" className="acc-btn" aria-expanded="false">
                                            <span className="accordion-title">Are there any additional fees?</span>
                                            <span className="icon" aria-hidden="true"></span>
                                        </button>
                                        <div className="accordion-content">
                                            <p>
                                                None at all—what you see is what you pay!
                                            </p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="text-bottom wow fadeInRight">
                                <p>Still have questions? Let us know, and we’ll be happy to help!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
